/** @typedef {import('../lib/types.js').NotesRailNoteWire} NotesRailNoteWire */
import { blocksToPlainText } from '../lib/blocksToPlainText'
import { getPrimaryNoteTabBlocks } from '../lib/noteDetailTabs'
import { noteContentPreview } from '../lib/noteContentPreview'
import { buildDefaultTabContent } from './buildDefaultTabContent'

/** @param {number} daysAgo @param {number} hours @param {number} minutes */
export function noteAt(daysAgo, hours = 12, minutes = 0) {
  const d = new Date()
  d.setDate(d.getDate() - daysAgo)
  d.setHours(hours, minutes, 0, 0)
  return d
}

/**
 * @param {Omit<NotesRailNoteWire, 'description' | 'body'> & {
 *   content: import('../lib/types.js').NoteContentBlock[],
 *   tabContent?: Record<string, import('../lib/types.js').NoteContentBlock[]>,
 *   description?: string,
 * }} note
 * @returns {NotesRailNoteWire}
 */
export function withContent(note) {
  const tabContent =
    note.tabContent ??
    (note.kind === 'meeting'
      ? buildDefaultTabContent(note.id, true)
      : {
          notes: note.content,
          chat: [{ type: 'paragraph', text: '' }],
        })

  const merged = { ...note, tabContent, content: note.content }
  const primaryBlocks = getPrimaryNoteTabBlocks(merged)
  const body = blocksToPlainText(primaryBlocks)
  const description = note.description ?? noteContentPreview(primaryBlocks, body)
  return { ...merged, body, description, content: primaryBlocks }
}
